import {Injectable} from '@angular/core';
import {Message} from './message';
import {SentryErrorHandler} from '@sentry/angular';

@Injectable({providedIn: 'root'})
export class ToastService {
  messages: Message[] = [];

  private readonly sentryErrorHandler = new SentryErrorHandler({
    logErrors: false,
    showDialog: true,
    dialogOptions: {
      lang: 'de',
      onLoad() {
        // get rid of the "Powered by Sentry" text
        document.querySelector('.powered-by')?.remove();
      },
    },
  });

  add(message: Message) {
    this.messages.push(message);
  }

  addTemporary(message: Message, duration = 5000) {
    this.add(message);
    message.timeoutId = setTimeout(() => this.remove(message), duration);
  }

  remove(message: Message) {
    this.messages.splice(this.messages.indexOf(message), 1);
  }

  info(title: string, message: string) {
    this.addTemporary({
      type: 'info',
      title,
      message,
    });
  }

  success(title: string, message: string) {
    this.addTemporary({
      type: 'success',
      title,
      message,
    });
  }

  warning(title: string, message: string) {
    this.addTemporary({
      type: 'warning',
      title,
      message,
    });
  }

  error(title: string, message: string, error?: any) {
    if (error) {
      console.error(title, message, error.error?.message);
      this.captureError(error);
    }
    this.add({
      type: 'error',
      title,
      message,
    });
  }

  captureError(error: any) {
    console.error(error);
    this.sentryErrorHandler.handleError(error);
  }
}
